let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bfhXH")).then(() => parcelRequire('l5Yc7'));